import {
    Form, FormButton, FormButtonContainer, FormItem, FormSubmitHandler, useForm,
    OptionProps, SelectInput, useAlerts, FormItemType
} from "@sis/react-library"
import { Example1Dto } from "./FormSamplesNonFieldtemsPage";
import { Alert, Box } from "@mui/material";

/////////////////////////////////////////////////////////////////////////////////////////////
// The Form can keep track of an item where there's no user input
// The example gives a question, and the answer is set internally in code, there is no
// user input for it.
/////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////////////////////
// Interface for the form (see basic usage example for more information).
/////////////////////////////////////////////////////////////////////////////////////////////
// allow no members for shorter name to be more readable below
// eslint-disable-next-line
interface T extends Example1Dto { }

interface FormSamplesNonFieldtemsExample1FormProps {
    onSubmit: FormSubmitHandler<Example1Dto>;
    submitting: boolean;
}

export const FormSamplesNonFieldtemsExample1Form = ({
    onSubmit, submitting
}: FormSamplesNonFieldtemsExample1FormProps) => {

    const formName = 'FormNonFieldtemsExample1';

    const questionOptions: OptionProps[] = [
        { value: 1, description: "What colour is the sky?" },
        { value: 2, description: "Which continent does France belong?" },
        { value: 3, description: "What language do they speak in Germany" },
        { value: 4, description: "Is a Panda a mammal or an insect?" },
        { value: 5, description: "You can't submit on this question?" }
    ]

    const { resetForm, setItem, getItem } = useForm<T>(formName);
    const { confirm } = useAlerts();

    const handleCancel = () => {
        confirm('Cancel', 'Are you sure you want to cancel and loose your changes?',
            () => { resetForm() },
            "Yes", "No"
        );
    }

    const handleQuestionChange = (questionId: FormItemType) => {
        setItem('answer', getAnswer(questionId));
    }

    const getAnswer = (questionId: FormItemType) => {
        switch (questionId) {
            case 1: return "Blue";
            case 2: return "Europe";
            case 3: return "German";
            case 4: return "Mammal";
            case 5: return null;
            default: return null;
        }
    }

    const validationAnswerCannotBeNull = (val: FormItemType) => {
        return val !== null;
    }

    const answerField = getItem('answer');

    return (
        <>
            <Form<T>
                name={formName}
                onSubmit={onSubmit}
                submitting={submitting}
                beforeLeaveText='You have made changes, are you sure you want to leave ?'
                /////////////////////////////////////////////////////////////////////////////////
                // additionalItems is where you can create extra items for the form to keep
                // track of where there's no user input.
                // It can also have rules and initialValue. 
                // (or the initialValue can come from initialValues passed into the form props)
                /////////////////////////////////////////////////////////////////////////////////
                additionalItems={[
                    {
                        name: "answer", initialValue: 'no answer',
                        rules: [{ type: "custom", checkRule: validationAnswerCannotBeNull, message: "Select a valid question" }]
                    }
                ]}
            >
                <FormItem<T>
                    formField="question"
                    label="Select a question"
                    onItemChange={handleQuestionChange}
                    element={<SelectInput options={questionOptions} hideBlankSelection />}
                />
                <FormButtonContainer>
                    <FormButton
                        formButtonText='Cancel'
                        onClick={() => { handleCancel() }}
                    />
                    <FormButton
                        formButtonText='Submit'
                        submitButton
                    />
                </FormButtonContainer>
            </Form>
            {answerField?.errorMessage &&
                <Box sx={{ paddingTop: 2 }}>
                    <Alert severity="error">{answerField.errorMessage}</Alert>
                </Box>
            }
        </>
    )
}